import { Roles } from '@src/context/AuthorizationContext/types';

export interface AgentConfinsBase {
  address: string;
  bank_account_name: string;
  bank_account_no: string;
  bank_branch: string;
  bank_id: string;
  birth_place: string | null;
  city: string;
  company_id: string;
  company_name: string;
  corporate_email: string;
  district: string;
  dt_birthday: string | null;
  dt_join: string;
  dtm_upd: string;
  emmp_status: boolean;
  emp_name: string;
  emp_no: string;
  id_number: string;
  id_type: string;
  is_internal_marketing_employee: boolean;
  job_title_code: string;
  job_title_name: string;
  marketing_id: string;
  marital_status_id: string | null;
  mobile_phone_no: string;
  nik_marketing: string;
  office_location_area_id: string;
  office_location_region_id: string;
  pos_id: string;
  position_code: string;
  profile_ba: string;
  rt: string;
  rw: string;
  sub_branch_id: string;
  sub_district: string;
  superior_emp_name: string;
  superior_emp_no: string;
  superior_marketing_id: string;
  tax_number: string;
  work_location_code: string;
  work_location_name: string;
  zip_code: string;
}

export enum ProductId {
  '4W' = '1',
  '2W' = '2',
  'PBF' = '3',
  'None' = '',
}

export enum RolesWithProduct {
  'AM' = Roles.Am,
  'ABPM' = Roles.Abpm,
  'BM' = Roles.Bm,
  'SPV.4W' = `${Roles.Spv}.${ProductId['4W']}`,
  'SPV.2W' = `${Roles.Spv}.${ProductId['2W']}`,
  'SPV.PBF' = `${Roles.Spv}.${ProductId['PBF']}`,
  'None' = '',
}
